/**
 * Print Styles Component - Shared print styles for reports
 *
 * @description Reusable print styles component to ensure consistent printing
 *              across all report pages
 * @copyright 2026 Guardrail Technologies
 */

export const PrintStyles = () => (
  <style>{`
    @media print {
      body * {
        visibility: hidden;
      }
      .print-container, .print-container * {
        visibility: visible;
      }
      .print-container {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
      }
      .no-print {
        display: none !important;
      }
      .print-only {
        display: block !important;
      }
      .print-break {
        page-break-before: always;
      }
      .print-section {
        page-break-inside: avoid;
      }
    }
    .print-only {
      display: none;
    }
  `}</style>
);
